export default "__VITE_ASSET__CRH5XyHJ__"